<template>
	<div class="details">
		<div class="container">
			<div class="row">
				<div class="col-md-3 pe-xl-5">
					<div class="pe-xl-3">

						<!-- Side Menu -->
						<ul class="nav nav-pills sidebar-nav flex-column">
							<li class="nav-item">
								<router-link to="/details" :disabled="!$store.getters.personal.completed || $store.getters.basic.finished" :class="{'nav-link': true, 'finished': $store.getters.basic.finished}" id="basicInformationNav">Basic Information</router-link>
							</li>
							<li class="nav-item">
								<router-link to="/details/contact-tax-reporting" :disabled="!$store.getters.basic.completed || $store.getters.contact.finished"  :class="{'nav-link': true, 'finished': $store.getters.contact.finished}" id="contactTaxReportingNav">Contact &amp; Tax Reporting</router-link>
							</li>
							<li class="nav-item" v-if="$store.getters.kyc.required">
								<router-link to="/details/kyc" :disabled="!$store.getters.contact.completed || $store.getters.kyc.finished"  :class="{'nav-link': true, 'finished': $store.getters.kyc.finished}" id="kycNav">Identity Verification</router-link>
							</li>
							<li class="nav-item">
								<router-link to="/details/investment-plan" :disabled="!$store.getters.contact.completed || $store.getters.investment.finished"  :class="{'nav-link': true, 'finished': $store.getters.investment.finished}" id="investmentPlanNav">Investment Plan</router-link>
							</li>
							<li class="nav-item">
								<router-link to="/details/bank-account" :disabled="!$store.getters.investment.completed || $store.getters.bankAccount.finished" :class="{'nav-link': true, 'finished': $store.getters.bankAccount.finished}" id="bankAccountNav">Bank Account</router-link>
							</li>
							<li class="nav-item">
								<router-link to="/details/agreements" :disabled="!$store.getters.bankAccount.completed || $store.getters.agreements.finished" :class="{'nav-link': true, 'finished': $store.getters.agreements.finished}" id="agreementsNav">Agreements</router-link>
							</li>
							<li class="nav-item">
								<router-link to="/review" :disabled="!$store.getters.agreements.completed" class="nav-link" id="reviewFinishNav">Review &amp; Finish</router-link>
							</li>
						</ul>

						<!-- Side Progress -->
						<div class="progress-box">
							<h5>Completion</h5>
							<p>Good job, almost there</p>
							<div class="pie-chart-wrapper">
								<div class="pie-chart" id="chart-1" :style="{'--p': progress}">
									<span>{{ progress }}%</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-9 ms-auto">

					<!-- Form Box -->
					<div class="form-box">
						<router-view/>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: "DetailsForm",
	data() {
        return {
		}
	},
	computed: {
        progress() {
            if(this.$store.getters.agreements.completed) return 100;
            if(this.$store.getters.bankAccount.completed) return 90;
            if(this.$store.getters.investment.completed) return 75;
            if(this.$store.getters.contact.completed) return 60;
            if(this.$store.getters.basic.completed) return 45;
            if(this.$store.getters.personal.completed) return 30;
            if(this.$store.getters.auth.completed) return 15;
            return 0;
		}
	},
}
</script>

<style lang="scss">
.details {
	padding: 5rem 0;
	background: #f1f6f8;
	min-height: calc(100vh - 5.5rem - 2px);

	@media (max-width: 767px) {
		padding: 0 0 2.5rem 0;
		background: #fff;
	}

	h2 {
		font-weight: bold;
		color: #16193a;
		font-size: 3rem;
		margin: 0 0 1rem 0;

		@media (min-width: 768px) and (max-width: 991px) {
			font-size: 2.5rem;
		}

		@media (max-width: 767px) {
			font-size: 1.5rem;
		}
	}

	h4 {
		font-size: 1.75rem;
		font-weight: bold;
		color: #16193A;

		@media (max-width: 767px) {
			font-size: 1.25rem;
		}

		.text-muted {
			color: #dcddde;
			font-weight: 300;
		}
	}

	p {
		color: #16193A;
		font-size: 1.25rem;
		margin: 0;

		@media (max-width: 767px) {
			font-size: 1rem;
		}

		&.small {
			font-size: 0.9rem;
		}

		a {
			color: #1697d6;
			text-decoration: none;
		}
	}
}

.sidebar-nav {
	margin-top: 1.5rem;

	@media (max-width: 767px) {
		display: none;
	}

	.nav-item {
		.nav-link {
			color: #16193a;
			font-size: 1.15rem;
			padding: 0.75rem 1rem;
			border-radius: 0.35rem;
			cursor: pointer;
			margin-bottom: 0.25rem;
			transition: 0.15s ease all;

			&[disabled] {
				pointer-events: none;
				user-select: none;
			}

			&:hover {
				background: lighten(#dee5ea, 3%);
			}

			&.router-link-exact-active {
				background: #dee5ea;
				font-weight: bold;
			}

			&.finished {
				opacity: 0.5;
			}
		}
	}
}

.progress-box {
	padding: 3rem 2.5rem;
	background: #f1efed;
	text-align: center;
	border-radius: 0.25rem;
	margin-top: 3rem;
	color: #16193a;

	@media (max-width: 767px) {
		text-align: left;
		padding: 1rem 1.5rem 1rem 4.5rem;
		position: relative;
		width: calc(100% + 1.5rem);
		margin: 0 -0.75rem;
	}

	h5 {
		font-size: 1.15rem;
		font-weight: bold;
		margin: 0;

		@media (max-width: 767px) {
			font-size: 1rem;
		}
	}

	p {
		margin: 0 0 1.5rem 0;
		font-size: 1rem;

		@media (max-width: 767px) {
			font-size: 0.9rem;
			margin: 0;
		}
	}

	.pie-chart-wrapper {
		position: relative;
		width: 6.5rem;
		height: 6.5rem;
		margin: auto;

		&:before {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			border-radius: 50%;
			border: 10px solid #fff;
			content: ' ';
			z-index: 0;

			@media (max-width: 767px) {
				border-width: 5px;
			}
		}

		@media (max-width: 767px) {
			width: 3rem;
			height: 3rem;
			position: absolute;
			top: 0;
			bottom: 0;
			left: 1rem;
		}
	}

	@keyframes p {
		from{--p:0}
	}

	.pie-chart {
		--p:20;
		--b:10px;
		--c:#F37021;
		--w:6.5rem;
		width: 6.5rem;
		height: 6.5rem;
		border-radius: 50%;
		text-align: center;
		font-size: 1.25rem;
		color: #F37021;
		font-weight: bold;
		margin: auto;
		position:absolute;
		top: 0;
		left: 0;
		display:inline-grid;
		place-content:center;
		animation: p 1s .5s both;
		z-index: 1;

		@media (max-width: 767px) {
			font-size: 0.8rem;
			--w:3rem;
			width: 3rem;
			height: 3rem;
			--b:5px;
		}

		&:before,
		&:after {
			content:"";
			position:absolute;
			border-radius:50%;
		}

		&::before {
			inset:0;
			background:
					radial-gradient(farthest-side,var(--c) 98%,#0000) top/var(--b) var(--b) no-repeat,
					conic-gradient(var(--c) calc(var(--p)*1%),#0000 0);
			-webkit-mask:radial-gradient(farthest-side,#0000 calc(99% - var(--b)),#000 calc(100% - var(--b)));
			mask:radial-gradient(farthest-side,#0000 calc(99% - var(--b)),#000 calc(100% - var(--b)));
		}

		&:after {
			inset:calc(50% - var(--b)/2);
			background:var(--c);
			transform:rotate(calc(var(--p)*3.6deg)) translateY(calc(50% - var(--w)/2));
		}
	}
}

.form-box {
	background: #fff;
	padding: 5rem 7.5rem;
	border-radius: 0.35rem;
	box-shadow: rgba(10,10,10,0.035) 0 0 2rem;

	&.completed-form-box {
		@media (max-width: 767.99px) {
			text-align: left !important;
		}

		h1 {
			padding: 0 15%;

			@media (max-width: 767px) {
				padding: 0;
			}
		}
	}

	@media (min-width: 768px) and (max-width: 991px) {
		padding: 2rem 2.5rem;
	}

	@media (max-width: 767px) {
		padding: 2rem 0;
		box-shadow: none;
	}
}
</style>